import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import moment from "moment";
import React, { useEffect, useState } from "react";
export default function FinancialStatus(param) {
    var statusID = param.statusID, statusName = param.statusName, docDueDate = param.docDueDate;
    var _useState = _sliced_to_array(useState({
        color: "#3FA5FF",
        bg: "#E5FAFF",
        statusName: "รอตรวจสอบ",
        isAfterDueDate: false
    }), 2), statusObj = _useState[0], setStatusObj = _useState[1];
    useEffect(function() {
        setStatusObj(function(prev) {
            return _object_spread_props(_object_spread({}, prev), {
                isAfterDueDate: statusID === 3 && docDueDate && moment().isAfter(moment(docDueDate))
            });
        });
        switch(statusID){
            case 2:
                setStatusObj(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        color: "#747474",
                        bg: "#F4F4F4",
                        statusName: statusName
                    });
                });
                break;
            case 3:
                setStatusObj(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        color: "#FF731D",
                        bg: "rgba(255, 115, 29, 0.15)",
                        statusName: statusName
                    });
                });
                break;
            case 4:
                setStatusObj(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        color: "rgba(114, 225, 40, 0.87)",
                        bg: "rgba(238, 251, 229, 1)",
                        statusName: statusName
                    });
                });
                break;
            case 5:
                setStatusObj(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        color: "rgba(249, 80, 87, 1)",
                        bg: "rgba(255, 0, 0, 0.15)",
                        statusName: statusName
                    });
                });
                break;
            case 6:
                setStatusObj(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        color: "#FDB428",
                        bg: "#FFF6E5",
                        statusName: statusName
                    });
                });
                break;
            default:
                setStatusObj(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        color: "#3FA5FF",
                        bg: "#E5FAFF",
                        statusName: "รอตรวจสอบ"
                    });
                });
                break;
        }
    }, [
        statusID,
        docDueDate
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            statusObj.isAfterDueDate && /*#__PURE__*/ _jsx("div", {
                className: "text-[#FF0000] text-center",
                children: "เกินกำหนด"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "px-3 py-1 mx-auto",
                style: {
                    color: statusObj.color,
                    backgroundColor: statusObj.bg,
                    borderRadius: "20px"
                },
                children: statusObj.statusName
            })
        ]
    });
}
